import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../lib/cn.js';
const SIZE_CLASSES = {
    sm: 'size-6 text-xxs',
    md: 'size-7.5 text-xs',
    lg: 'size-10 text-sm',
};
export function Avatar({ initials, src, alt, size = 'md', className, ...rest }) {
    return (_jsx("span", { role: src ? undefined : 'img', "aria-label": src ? undefined : (alt ?? initials), ...rest, className: cn('inline-grid place-items-center overflow-hidden rounded-pill font-mono font-medium text-[var(--color-ink)]', SIZE_CLASSES[size], !src &&
            'bg-[linear-gradient(135deg,var(--color-steel),color-mix(in_oklab,var(--color-steel)_60%,var(--color-canvas)))]', className), children: src ? _jsx("img", { src: src, alt: alt ?? '', className: "size-full object-cover" }) : initials }));
}
